import { useRef, useState } from "react";
import { HiChevronLeft } from "react-icons/hi";
import { MdPerson, MdPersonAdd } from "react-icons/md";
import { RiSearch2Line } from "react-icons/ri";
import { ThreeDots } from "react-loader-spinner";
import { useQuery } from "react-query";
import api from "src/rest/api";
import Inputfield from "../../components/inputfield";
import MutableIcon from "../../components/mutable-icon";
import CreateForm from "./create-form";
import { FilterAndSort } from "./functions";
import Students from "./list";

interface StudentsListProps {
  dismiss: () => void;
  onSelect: (id: StudentList) => void;
}

export interface StudentList {
  id: string;
  name: string;
  username: string;
  gender: string;
  birthdate: string;
  photourl: string;
  status: "blocked" | "active";
}

export default function StudentsList(props: StudentsListProps) {
  const listing = useQuery("Students", () =>
    api
      .post<StudentList[]>("/students/list")
      .then((res) => res.data)
      .catch((err) => {
        alert(JSON.stringify(err));
        throw new Error(err);
      }),
  );

  const ref = useRef<HTMLDivElement>(null);
  const [create, setCreate] = useState(false);
  const [filter, setFilter] = useState("");

  const filtered = FilterAndSort(filter, listing.data);

  function ToggleCreate() {
    setCreate(true);
  }

  function onGoBack() {
    if (create) {
      listing.refetch();
      setCreate(false);
    }

    props.dismiss();
  }

  function onAdd() {
    setCreate(false);
    listing.refetch();
  }

  function OnEditTitle(t: string) {
    return t;
  }

  function StudentListComp() {
    if (listing.isLoading) {
      return (
        <div className="flex w-full flex-1 items-center justify-center">
          <ThreeDots height={60} width={60} color="black" />
        </div>
      );
    } else if (!listing.data) {
      return (
        <div className="flex flex-col items-center justify-center opacity-70">
          <MdPerson />
          <h5>[{JSON.stringify(listing.error)}] Erro ao carregar alunos</h5>
          <button
            className="mt-3 cursor-pointer rounded bg-zinc-300 p-2"
            onClick={() => window.location.reload()}
          >
            RECARREGAR
          </button>
        </div>
      );
    } else if (listing.data?.length === 0) {
      return (
        <div className="flex flex-col items-center justify-center opacity-50">
          <MdPerson />
          <h5>Você não possui alunos cadastrados!</h5>
        </div>
      );
    }

    return <Students list={filtered} onSelect={props.onSelect} />;
  }

  return (
    <div className="flex flex-1 flex-col overflow-hidden p-4" ref={ref}>
      {create ? (
        <CreateForm onGoBack={onGoBack} onAdd={onAdd} />
      ) : (
        <div className="flex h-full flex-col">
          <div className="mb-8 flex items-center justify-between">
            <MutableIcon icon={HiChevronLeft} size={40} onClick={onGoBack} />
            <div className="mx-8 flex h-20 w-full flex-col items-center justify-center">
              {create ? (
                <h3 className="text-lg font-bold">Cadastrar Aluno</h3>
              ) : (
                <>
                  <h3 className="text-lg font-bold">Alunos</h3>
                  <Inputfield
                    icon={RiSearch2Line}
                    radius={"25px"}
                    width={"100%"}
                    onEndText={OnEditTitle}
                    onChangeText={setFilter}
                    inputProps={{
                      placeholder: "Pesquisar por aluno...",
                    }}
                  />
                </>
              )}
            </div>
            <MutableIcon
              disabled={create}
              icon={MdPersonAdd}
              size={40}
              onClick={ToggleCreate}
            />
          </div>
          <ul className="flex flex-1 flex-col overflow-x-hidden overflow-y-scroll">
            <StudentListComp />
          </ul>
        </div>
      )}
    </div>
  );
}
